import { getFormattedDateString } from "./lib";

export const date = (dateString) => {
    const dateObject = new Date(dateString)
    return getFormattedDateString(dateObject)
};